import { createStore, applyMiddleware, combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import thunkMiddleware from 'redux-thunk'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import appState from './AppState'
import appDeviceConfiguration from './AppDeviceConfiguration'
import customer from './Customer'
import customerOrderingPreference from './CustomerOrderingPreference'
import customerPayment from './CustomerPayment'
import event from './Event'
import eventType from './EventType'
import order from './Order'
import revenueCenter from './RevenueCenter'
import staff from './Staff'
import suite from './Suite'
import venues from './Venues'
import employeeRole from './EmployeeRole'

const persistSuitesConfig = {
  storage,
  key: 'suitesManager',
  blacklist: 'venues'
}

const persistVenuesConfig = {
  storage,
  key: 'venues',
  whitelist: ['selectedId'],
}

const rootReducer = combineReducers({
  venues: persistReducer(persistVenuesConfig, venues),
  appDeviceConfiguration,
  customer,
  customerOrderingPreference,
  customerPayment,
  employeeRole,
  event,
  eventType,
  order,
  revenueCenter,
  staff,
  suite,
  appState,
  form: formReducer,
})

const persistedReducer = persistReducer(persistSuitesConfig, rootReducer)
const middleware = composeWithDevTools(applyMiddleware(thunkMiddleware))

export default () => {
  const store = createStore(persistedReducer, middleware)
  const persistor = persistStore(store)

  return { store, persistor }
}
